export default ["left", "right", "center"];